import React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import PageTitle from "./PageTitle";
import Spacer from "./Spacer";
import "./DemographicsPage.styles.css";

const DisconnectionNoticePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContinue = () => {
    // Preserve all URL parameters and add wasDisconnected flag
    const queryParams = new URLSearchParams(location.search);
    queryParams.set('wasDisconnected', '1');
    const newUrl = '/post-game-questions?' + queryParams.toString();
    console.log("DisconnectionNoticePage: Navigating to:", newUrl);
    navigate(newUrl);
  };

  return (
    <div className="demographics-bg">
      <div className="demographics-card fade-in">
        <PageTitle title="Study Interruption Notice" />
        <Spacer />
        
        {/* Main explanation */}
        <div style={{
          background: '#fff3e0',
          border: '1.5px solid #f57c00',
          borderRadius: 12,
          padding: '22px 18px',
          margin: '0 auto 18px auto',
          maxWidth: 480,
          textAlign: 'left',
          boxShadow: '0 2px 12px rgba(245, 124, 0, 0.08)',
          fontSize: 16,
          color: '#e65100',
          lineHeight: 1.5
        }}>
          <div style={{ marginBottom: 12, fontWeight: 600, fontSize: 18 }}>
            ⚠️ Connection Issue Detected
          </div>
          <div style={{ marginBottom: 8 }}>
            Thank you for participating in our study! Unfortunately, you or your partner experienced 
            a connection issue during the middle of the study, which prevented you from proceeding 
            to the next page.
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>What this means:</strong> While this technical issue was beyond your control, 
            we want to ensure you are properly compensated for your valuable time and participation 
            up to the point where the disconnection occurred.
          </div>
          <div style={{ marginBottom: 8 }}>
            <strong>Your compensation:</strong> You will be compensated based on a portion of the base pay plus the bonus which is the amount of money 
            you collected up to the point where the disconnection occurred. This ensures you receive 
            fair compensation for the portion of the study you completed. The base pay is 100 tokens and the bonus is 100 tokens.
          </div>
          <div>
                      <strong>Next steps:</strong> Please complete the post-game questions and demographic questions on the following pages, 
          and then you will receive a completion code to message the researcher for your compensation.
          </div>
        </div>

        {/* Instructions box */}
        <div style={{ 
          fontSize: 15, 
          color: '#666', 
          marginTop: 8,
          background: '#f5f5f5',
          borderRadius: 8,
          padding: '12px 16px',
          border: '1px solid #e0e0e0',
          maxWidth: 480,
          margin: '0 auto 18px auto'
        }}>
          <strong>What happens next:</strong>
          <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
            <li>Share your thoughts about the game experience</li>
            <li>Complete the demographic questions</li>
            <li>Receive your completion code</li>
            <li>Message the researcher with the code for compensation</li>
          </ul>
        </div>

        {/* Continue button */}
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <button
            onClick={handleContinue}
            style={{
              background: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '12px 32px',
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#1565c0';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#1976d2';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.3)';
            }}
          >
            Continue to Post-Game Questions
          </button>
        </div>

        {/* Final note */}
        <div style={{ 
          fontSize: 15, 
          color: '#888', 
          marginTop: 16,
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          We apologize for any inconvenience caused by the technical issue.
        </div>
      </div>
    </div>
  );
};

export default DisconnectionNoticePage; 